import * as React from "react";
import {Tab} from 'semantic-ui-react'
import {HistoryTable} from "./HistoryTable";
import {SearchView} from "./SearchView";
import {DraftTable} from "./DraftTable";
import {authentication} from "../../../../../../authentication";
import {FieldDescriptionView} from "./FieldDescriptionView";
import {FieldChangesView} from "./FieldChangesView";
import {ReportTimeBuilder} from "./ReportTimeBuilder";
import {focusesOnField, shadowCursor} from "../newNavTree/NavTree";
import {useEffect} from "react";
import {retry} from "@reduxjs/toolkit/query";
import {ApiGatewayTester} from "./ApiGatewayTester";
import {clampTabIndex} from "../../../../context/TabSession";


function RightSideTabView(props: any) {

    const initialPanes = [
        { pos: 1, menuItem: 'History', render: (props: any) => <Tab.Pane><HistoryTable reloadFromContext={props.reloadFromContext}/></Tab.Pane> },
        { pos: 3, menuItem: 'Drafts', render: (props: any) => <Tab.Pane><DraftTable reloadFunction={props.onCloseCompareModal} /></Tab.Pane> },
        { pos: 4, menuItem: 'Description', render: () => <Tab.Pane><FieldDescriptionView /></Tab.Pane> },
        { pos: 5, menuItem: 'Changes', render: () => <Tab.Pane><FieldChangesView /></Tab.Pane> },
        { pos: 6, menuItem: 'Api Gateway Tester', render: () => <Tab.Pane><ApiGatewayTester /></Tab.Pane>}
    ]

    const [loading, setLoading] = React.useState(true)
    const [panes, setPanes] = React.useState(initialPanes)

    useEffect(() => {
        setLoading(true)
        let tempPanes = panes
        if(authentication.isSuperUser &&
            tempPanes.find(pane => pane.menuItem === 'Search') === undefined) {
            tempPanes.push(
                {
                    pos: 2,
                    menuItem: 'Search',
                    render: props => <Tab.Pane>
                        <SearchView
                            auth={props.auth}
                            searchPath={props.fieldPath}
                            onCloseCompareModal={props.onCloseCompareModal}
                        />
                    </Tab.Pane>
                }
            )
        }
        setPanes(tempPanes.sort((a, b) => a.pos - b.pos))
        setLoading(false)
    },[]);

    useEffect(() => {
        setLoading(true)
        let tempPanes = panes

        let currentPath = focusesOnField.value?.path
        if(currentPath?.includes("timeReference")){
            if(tempPanes.find(pane => pane.menuItem === 'Report Time Builder') === undefined) {
                tempPanes.push(
                    {pos: 7, menuItem: 'Report Time Builder', render: () => <Tab.Pane><ReportTimeBuilder/></Tab.Pane>},
                )
            }
        } else {
            tempPanes = tempPanes.filter(pane => pane.menuItem !== 'Report Time Builder')
        }
        setPanes(tempPanes.sort((a, b) => a.pos - b.pos))
        setLoading(false)
    },[focusesOnField.value]);

    console.log("RightSideTabView panes: ", panes.map(pane => pane.menuItem))

    function drawTabs() {
        return <Tab
            id={"RightSideTabView"}
            className={"flexTab"}
            {...props = props}
            panes={panes}
            defaultActiveIndex={clampTabIndex(props.context.tabSession.configRightSideTab, panes)}
            onTabChange={(_, data) => {
                props.context.setSingleTabSession("configRightSideTab", data.activeIndex)
            }}
            key={panes.length}
        />
    }

    if(loading) {
        return <div>Loading...</div>
    } else {
        return drawTabs()
    }
}

export default RightSideTabView